import { useCallback, useEffect, useRef, useState } from 'react'

export const useTreeTranslate = (treeData: any) => {
  const [translate, setTranslate] = useState({ x: 350, y: 100 })
  const treeContainerRef = useRef<HTMLDivElement>(null)

  const updateTranslate = useCallback(() => {
    if (treeContainerRef.current) {
      const { width, height } = treeContainerRef.current.getBoundingClientRect()
      setTranslate({ x: width / 2, y: height / 4 })
    }
  }, [])

  useEffect(() => {
    updateTranslate()
    window.addEventListener('resize', updateTranslate)
    return () => window.removeEventListener('resize', updateTranslate)
  }, [updateTranslate])

  useEffect(() => {
    if (treeData) {
      updateTranslate()
    }
  }, [treeData, updateTranslate])

  return {
    translate,
    treeContainerRef,
  }
}
